import { asText as asPrismicText } from "@prismicio/client"

import type { BasicObject } from "@bounce/util"
import { clean, isString } from "@bounce/util"

import type { Interpolations } from "./interpolate"
import { interpolateText } from "./interpolate"

type AsPrismicTextOption = Parameters<typeof asPrismicText>[0]

type AsInterpolateTextOption = {
  field: AsPrismicTextOption | string
  interpolations?: Interpolations
}

export const asInterpolateText = ({ field, interpolations }: AsInterpolateTextOption): string => {
  if (!field) return ""

  // Interpolate text
  if (isString(field)) {
    return interpolateText(field, interpolations)
  }

  // Interpolate and convert Prismic RichText to a string
  const children = asPrismicText(field)
  return interpolateText(children, interpolations)
}

/**
 * Clean out empty fields from prismic
 * @param data
 */
export const cleanPrismicData = <T extends BasicObject<any>>(data: T): Partial<T> => {
  const cleanData = clean(data, false)

  Object.keys(cleanData).forEach(k => {
    if (Array.isArray(cleanData[k])) {
      const filtered = cleanData[k]?.filter((v: any) => !(typeof v === "object" && v?.text === ""))

      if (filtered.length === 0) {
        delete cleanData[k]

        return
      }

      Object.assign(cleanData, { [k]: filtered })
    }
  })

  return cleanData
}

export const asData = <TItem>(r: TItem[]) => (r.length === 0 ? null : r)
